<div class="fixed top-0 bottom-0 w-full h-full ">
  <div class="flex flex-col w-full width-75 h-full transition-transform duration-400 ease-drawer bg-card"
    [ngClass]="{'-translate-x-full': opened, 'translate-x-0': !opened}">

    <!-- Header -->
    <div class="app-sidebar-header flex flex-0 items-center justify-start" >

      <!-- Toggle -->
      @if (!opened || (opened && !selectedChat)) {
        <div class="flex flex-auto items-center justify-center">
          <div class="flex flex-0 items-center justify-center w-16 ml-4 cursor-pointer" (click)="toggle()">
            <mat-icon class="icon-size-6" [svgIcon]="'heroicons_outline:shopping-cart'"></mat-icon>
          </div>
          <div class="text-lg font-medium text-secondary px-4 cursor-default">Carrito</div>
          @if (lines) {
            <button class="button-empty-cart" mat-button [color]="'accent'" [ngClass]="{'button-disabled': !canEditCart}"
              [disabled]="!canEditCart" (click)="deleteAllproducts()">
              Vaciar carrito
            </button>
          }
          <button class="ml-auto mr-4" mat-icon-button (click)="toggle()">
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
          </button>
        </div>
      }

    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto items-center border-t overflow-y-auto bg-[#E9ECEF] py-4">
      @for (data of dataSource; track data) {
        <div class="snap-start bg-card rounded-2xl shadow cards h-[13rem] md:h-[10rem]">
          <div class="flex h-full">
            <div class="image-container-sidebar">
              <img (click)="goToDetail(data.id)" class="max-w-xs rounded-2xl	" src="{{data.image || 'images/products/placeholder_thumbnail.png'}}" alt="Card cover image">
            </div>
            <div class="flex flex-col w-full p-4 justify-between">
              <div class="flex flex-0 items-center justify-between">
                <div class="text-lg font-medium text-secondary">{{data.name | truncate:50}}</div>
              </div>
              <div class="flex">
                <div class="basis-1/2 text-m font-light text-secondary">SKU: {{data?.sku}}</div>
                <div class="basis-1/2 text-m font-light text-secondary">Marca: {{data?.brand}}</div>
              </div>
              <div>
                <div class="text-m font-light text-secondary">Categoría: {{data?.categ_name}}</div>
              </div>
              <div class="flex mt-[0.5rem]">
                <div class="counter-container">
                  <div class="counter-control">
                    <button class="px-3 py-1 text-xl" (click)="decrement(data)" [disabled]="data?.maximum_quantity <= 0 || data?.quantity <= 1 || !canEditCart">-</button>
                    <input class="input-quantity" type="text" inputmode="numeric" pattern="[0-9]*" [value]="data.quantity" readonly />
                    <button class="px-3 py-1 text-xl" (click)="increment(data)" [disabled]="data?.stock <= 0 || data?.quantity >= data?.maximum_quantity || !canEditCart">+</button>
                  </div>
                  <div class="text-right w-full font-semibold mt-2">
                    {{data.price_unit | currency:'USD':'symbol'}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (canEditCart) {
            <div class="delete-icon bg-card rounded-2xl shadow" (click)="deleteProduct(data.product.id)">
              <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
            </div>
          }
        </div>
      }

      @if (!lines) {
        <div>
          <div class="flex justify-center mt-6">
            <img class="max-w-xs rounded-2xl" src="{{'images/products/empty_cart.png'}}" alt="Card cover image">
          </div>
          <div class="mt-12 text-right button-container">
            <button mat-button class="buttons" (click)="goProducts()">Comprar ahora</button>
          </div>
        </div>
      }
    </div>

    <!-- Footer -->
    @if (lines) {
      <div class="app-sidebar-footer flex flex-col items-center justify-between border-t p-4">
        <div class="flex items-center justify-between w-full text-md mt-1.5">
          <span class="text-secondary whitespace-nowrap mr-3">Subtotal:</span>
          <span class="mr-2">{{subtotalPrice | currency:'USD':'symbol'}}</span>
        </div>
        <div class="flex items-center justify-between w-full text-md mt-1.5">
          <span class="text-secondary whitespace-nowrap mr-3">Impuestos:</span>
          <span class="mr-2">{{taxPrice | currency:'USD':'symbol'}}</span>
        </div>
        <!-- @if (!addCodeBool) {
          <h1 class="text-right w-full cursor-pointer" (click)="addCode()">Aplicar codigo promocional</h1>
        } -->
        <!-- agregar codigo promocional -->
        @if (addCodeBool) {
          <div class="flex items-center w-full mt-4">
            <mat-form-field class="flex w-full" subscriptSizing="dynamic">
              <input class="w-full" matInput name="code" formControlName="code" placeholder="Tarjeta de regalo o codigo de descuento">
            </mat-form-field>
            <button class="flex items-center justify-between bg-primary text-white rounded-lg px-4 py-2 h-12">Aplicar</button>
          </div>
        }
        <button class="flex items-center justify-between bg-primary text-white rounded-lg px-4 py-2 w-full mt-4 " (click)="goToCheckout()">
          <div class="flex items-start flex-col">
            @if (cartData?.items_number === 1) {
              <span class="font-medium">{{ cartData?.items_number }} artículo</span>
            }
            @if (cartData?.items_number > 1) {
              <span class="font-medium">{{ cartData?.items_number }} articulos</span>
            }
            <span class="font-semibold">
              Total: {{totalPrice | currency:'USD':'symbol'}}
            </span>
          </div>
          <div class="flex items-center justify-center">
            Continuar <mat-icon [svgIcon]="'heroicons_outline:chevron-double-right'"></mat-icon>
          </div>
        </button>
      </div>
    }
  </div>
</div>
